var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2741_3692)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4505 27.9705C31.2485 28.4865 28.9355 22.0755 28.9355 22.0755C29.9655 18.9955 30.9855 8.48048 30.3455 5.27549C29.7055 2.06948 27.3055 2.18048 22.8955 1.30348C18.4065 0.403485 7.11652 -0.111515 4.66652 0.0204849C2.23152 0.147485 0.441522 1.81049 0.691522 5.15049C0.948522 8.48048 4.85452 20.8905 6.79152 23.9705C8.72152 27.0505 11.5745 26.5125 13.2765 26.3065C15.6105 26.0185 24.3965 23.9705 24.3965 23.9705C23.6105 22.9605 27.6535 27.4545 29.4505 27.9705ZM17.6665 8.59048L19.2305 5.26648H23.9105L18.7945 15.0085V20.7485H13.4245V15.0085L10.5645 9.56248L8.30152 5.26648H12.9815L16.1055 11.8915L17.6665 8.59048Z",
    fill: "#ED484A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_3692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYell);
export default __webpack_public_path__ + "static/media/yell.c74c93017c5e82175a754fe23bb0202d.svg";
export { ForwardRef as ReactComponent };